import PropTypes from 'prop-types'
import { Navigation, Keyboard, Controller, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Icon, useWindowSize } from '@moneymade/moneymade-ui'

import { toAutoPlayVideoUrl } from 'modules/discover/discoverUtils'
import { getCdnImg } from 'utils/getters'
import ImgLazy from 'components/ui/ImgLazy/ImgLazy'
import styles from './MediaSlider.module.scss'

const MediaSlider = ({ videos, media, isActive, handleOpenModal, handleSetSwiper, handleSetIndex }) => {
  const { screenWidth } = useWindowSize()

  return (
    <>
      <button type="button" className={`${styles.SwiperPrev} ${isActive?.prev ? styles.Hide : ''} swiper-button-prev`}>
        <Icon icon="icon-point-left" size={12} />
      </button>
      <button type="button" className={`${styles.SwiperNext} ${isActive?.next ? styles.Hide : ''} swiper-button-next`}>
        <Icon icon="icon-point-right" size={12} />
      </button>

      <Swiper
        className={styles.Slider}
        modules={[Pagination, Navigation, Keyboard, Controller]}
        slidesPerView={1}
        spaceBetween={10}
        pagination={{ clickable: true }}
        navigation={{ prevEl: '.swiper-button-prev', nextEl: '.swiper-button-next' }}
        keyboard
        cssMode
        onSwiper={handleSetSwiper}
        onSlideChange={({ activeIndex }) => handleSetIndex(activeIndex)}
      >
        <>
          {videos?.map((url, index) => (
            <SwiperSlide key={index}>
              {({ isActive: isActiveSwiper }) => (
                <div className={styles.IframeWrapper}>
                  <iframe
                    loading="lazy"
                    title="PreviewIframe"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    width="100%"
                    src={isActiveSwiper ? toAutoPlayVideoUrl(url) : url}
                    scrolling="no"
                    className={styles.Iframe}
                  />
                </div>
              )}
            </SwiperSlide>
          ))}

          {media?.map((url, index) => (
            <SwiperSlide key={index} className={styles.ImageWrapper}>
              <button type="button" onClick={handleOpenModal}>
                {index === 0 ? (
                  <img
                    src={getCdnImg(url, screenWidth <= 400 ? 400 : 600)}
                    alt="attachment"
                    className={styles.Image}
                    width="100%"
                    height="100%"
                  />
                ) : (
                  <ImgLazy
                    src={getCdnImg(url, screenWidth <= 400 ? 400 : 600)}
                    alt="attachment"
                    className={styles.Image}
                    width="100%"
                    height="100%"
                  />
                )}
              </button>
            </SwiperSlide>
          ))}
        </>
      </Swiper>
    </>
  )
}

MediaSlider.propTypes = {
  swiper: PropTypes.shape({
    navigation: PropTypes.shape({
      onPrevClick: PropTypes.func,
      onNextClick: PropTypes.func
    })
  }),
  videos: PropTypes.arrayOf(PropTypes.string),
  media: PropTypes.arrayOf(PropTypes.string),
  isActive: PropTypes.shape({
    prev: PropTypes.bool,
    next: PropTypes.bool
  }),
  handleOpenModal: PropTypes.func,
  handleSetSwiper: PropTypes.func,
  handleSetIndex: PropTypes.func
}

MediaSlider.defaultProps = {
  swiper: {},
  videos: [],
  media: [],
  isActive: {
    prev: false,
    next: false
  },
  handleOpenModal: () => {},
  handleSetSwiper: () => {},
  handleSetIndex: () => {}
}

export default MediaSlider
